exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.prompt-container[data-v-0e3a81a2] {\r\n    margin: 0 2.8rem 1rem 2.8rem; /** override for text wrap **/\n}\r\n", ""]);

// exports
